import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { SegmentationLegend } from './SegmentationLegend';
import type { SelectionProps } from './MapLayerOption';
import { MapLayerOption } from './MapLayerOption';

export const SegmentationLayerOption = (props: SelectionProps) => {
  const isSmallScreen = useSmallScreen();

  return (
    <MapLayerOption
      title="By segmentation"
      value={LayerType[LayerType.segmentation]}
      {...props}
    >
      {isSmallScreen &&
        props.selected === LayerType[LayerType.segmentation] && (
          <SegmentationLegend />
        )}
    </MapLayerOption>
  );
};
